/** n행시 이름의 음절 계산. 서버(`api/services/toast.py`)와 같은 규칙이다 —
 * 여기 값은 버튼을 잠그고 몇 줄이 나올지 알려주는 데만 쓴다. 경계를 실제로
 * 지키는 건 서버다(프론트 계산은 우회할 수 있다).
 */

const HANGUL_FIRST = 0xac00; // 가
const HANGUL_LAST = 0xd7a3; // 힣

export const MIN_NAME_SYLLABLES = 2;
// 이름 글자 수가 곧 줄 수다. 대상이 사람 이름만은 아니라서(지점명·팀명도 온다)
// 3글자로 좁히지 않는다 — "법조타운" 은 4행시다. 서버와 같은 값이어야 한다.
export const MAX_NAME_SYLLABLES = 8;

/** 이름에서 n행시 머리글자가 될 한글 완성형 글자만 순서대로 뽑는다.
 *
 * NFC 정규화가 먼저다. macOS·iOS 에서 붙여넣은 한글은 자모가 분해된 NFD 라
 * ("강" = ㄱ+ㅏ+ㅇ) 정규화 없이 세면 세 글자로 잡혀 줄 수 안내가 틀린다.
 * 공백·영문·이모지는 머리글자가 될 수 없어 빠진다("강 병욱" -> 3글자).
 */
export function nameSyllables(name: string): string[] {
  return [...name.normalize("NFC")].filter((c) => {
    const code = c.codePointAt(0) ?? 0;
    return code >= HANGUL_FIRST && code <= HANGUL_LAST;
  });
}

export function isAcrosticNameReady(name: string): boolean {
  const count = nameSyllables(name).length;
  return count >= MIN_NAME_SYLLABLES && count <= MAX_NAME_SYLLABLES;
}
